export const getFileUrl = (file: File | string | null) => {
  if (!file) return null;
  if (typeof file === "string") {
    return {
      url: file,
      fileName: file.split("/").pop(),
      ext: file.split(".")?.pop()?.toLowerCase() || "_",
    };
  }
  return {
    url: URL.createObjectURL(file),
    fileName: file.name,
    ext: file.name.split(".")?.pop()?.toLowerCase() || "_",
  };
};

export const getFileNameFromPath = (filePath: string) => {
  const fullName = filePath.split("/").pop() || "";
  const nameWithoutUuid = fullName.replace(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/,
    ""
  );
  return nameWithoutUuid;
};
